<template>
  <OrderPageSection>
    <div v-if="showTitle" class="order-item-title">
      {{ order.orderItems.length }} 件商品
    </div>
    <div class="order-item-cards">
      <OrderItemCard
        v-for="(item, index) in order.orderItems"
        :key="index"
        :index="index"
        :data="item"
        :is-rejected="isCreator && !!rejectedMap[item.id]"
        @readjustprice="onReAdjustPrice"
      />
    </div>
  </OrderPageSection>
</template>

<script>
import { analyseAdjustPriceVos } from "@/utils";
import OrderItemCard from "../widgets/OrderItemCard.vue";
import OrderPageSection from "../widgets/OrderPageSection.vue";

export default {
  components: { OrderPageSection, OrderItemCard },
  props: {
    order: Object,
    isCreator: Boolean,
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    rejectedMap() {
      const { rejecteds } = analyseAdjustPriceVos(this.order);
      return rejecteds;
    },
  },
  methods: {
    onReAdjustPrice(payload) {
      this.$emit("readjustprice", payload);
    },
  },
};
</script>

<style lang="less" scoped>
.order-item-title {
  height: 17/20rem;
  line-height: 17/20rem;
  font-size: 12/20rem;
  font-weight: 500;
  letter-spacing: 0;
}
</style>
